import { toPairs } from 'ramda'

import { PaymentSourceType } from 'app/dataTypes/reports/paymentSources'

import type { Request } from '../../index'


export const convertParams = (): [void, null] => ([undefined, null])

type ResultApi = Record<string, string>

export const convertResult = (data: ResultApi): Array<PaymentSourceType> => {
  return toPairs(data).map(([ID, title]) => ({ ID, title }))
}

export const GET_PAYMENT_SOURCES: Request<void, void, void> = [
  'reports/desktop_payment_sources',
  'get',
  ['data', 'sources'],
]
